// 1. Define the global array to store the classes
export const CLASSES_TESTED_FOR_HASH: any[] = [];

// 2. Define the Stage 3 class decorator
export function DECORATOR__class_serialization_tested_for_hash(target: Function, context: ClassDecoratorContext) {
  // Ensure we are decorating a class
  if (context.kind === 'class') {
    CLASSES_TESTED_FOR_HASH.push(target);
  }
}
